import React, { Component } from "react"
import { translate } from "react-translate"
import { Segment, Form, Dropdown, Button, Icon } from "semantic-ui-react"

import "./EditionParametreEnteteApercu.css"

class EditionParametreEnteteApercu extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    let { t } = this.props

    return (
      <Segment id="blocApercuEntete">
        {" "}
        <label id="labelApercuEntete">{t("label_apercu_entete")}</label>
        <Segment id="apercuPageEntete">
          <div id="apercuPageEnteteInfos">
            <p id="textApercuName">Derrick Black</p>
            <p>357 Lotissement Assafsaf</p>
            <p>Marrakech</p>
            <p>40000 Marrakech</p>
            <p>Maroc</p>
            <p>holis.oberbrunner@hotmail.com</p>
          </div>
          <Segment id="blocAdresseApercu">
            <p id="blocAdresseApercuName">Duane Waters</p>
            <p>6 rue d'Alexandrie</p>
            <p>75002 Paris</p>
            <p>France{" "}</p>
            <label id="dateBlocAdresse">{t("label_date")} 20/11/2017</label>
          </Segment>
        </Segment>
      </Segment>
    )
  }
}

export default translate("ProParamApercu")(EditionParametreEnteteApercu)



// WEBPACK FOOTER //
// ./src/components/Pro/Parametres/Entete/EditionParametreEnteteApercu.js